let invitationToken = '';

/**
 * Capture a military confirmation credential from the URL fragment and remove
 * it before any client telemetry can inspect window.location. The credential is
 * deliberately held only in this module's memory and can be consumed once.
 */
export const captureMilitaryConfirmationInvitation = () => {
  const isMilitaryRoute = /(?:^|\/)military-confirmation\/?$/.test(window.location.pathname);
  const match = isMilitaryRoute
    ? window.location.hash.match(/^#token=([A-Za-z0-9_-]{43})$/)
    : null;
  invitationToken = match ? match[1] : '';

  if (isMilitaryRoute && window.location.hash) {
    window.history.replaceState(
      null,
      document.title,
      `${window.location.pathname}${window.location.search}`,
    );
  }
};

/** Return the captured invitation exactly once. */
export const consumeMilitaryConfirmationInvitation = () => {
  const captured = invitationToken;
  invitationToken = '';
  return captured;
};
